import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { languagesAPI } from '../../services/api';

// Асинхронные экшены
export const fetchLanguages = createAsyncThunk(
  'languages/fetchLanguages',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await languagesAPI.getAll(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchLanguageById = createAsyncThunk(
  'languages/fetchLanguageById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await languagesAPI.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const languagesSlice = createSlice({
  name: 'languages',
  initialState: {
    items: [],
    selectedLanguage: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Синхронное обновление языка (используется при получении событий)
    updateLanguage: (state, action) => {
      const language = action.payload;
      const index = state.items.findIndex(item => item.id === language.id);
      
      if (index !== -1) {
        // Обновление существующего языка
        state.items[index] = {
          ...state.items[index],
          ...language,
        };
      } else {
        // Добавление нового языка
        state.items.push(language);
      }
      
      // Если открыта детальная страница языка, обновляем и её
      if (state.selectedLanguage && state.selectedLanguage.id === language.id) {
        state.selectedLanguage = {
          ...state.selectedLanguage,
          ...language,
        };
      }
    },
    
    // Удаление языка (используется при получении событий)
    deleteLanguage: (state, action) => {
      const id = action.payload;
      const idStr = id?.toString();
      
      if (!idStr) {
        console.error('Редьюсер: получен пустой ID для удаления языка');
        return;
      }
      
      state.items = state.items.filter(item => {
        const itemId = item.id?.toString();
        return itemId !== idStr;
      });
      
      // Если открыта детальная страница удаляемого языка, очищаем её
      if (state.selectedLanguage && state.selectedLanguage.id?.toString() === idStr) {
        state.selectedLanguage = null;
      }
    },
    
    // Сброс выбранного языка
    resetSelectedLanguage: (state) => {
      state.selectedLanguage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Обработка fetchLanguages
      .addCase(fetchLanguages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLanguages.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchLanguages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить языки';
      })
      
      // Обработка fetchLanguageById
      .addCase(fetchLanguageById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLanguageById.fulfilled, (state, action) => {
        state.selectedLanguage = action.payload;
        state.loading = false;
      })
      .addCase(fetchLanguageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить язык';
      });
  },
});

// Экспорт экшенов
export const { updateLanguage, deleteLanguage, resetSelectedLanguage } = languagesSlice.actions;

// Селекторы
export const selectAllLanguages = (state) => state.languages.items;
export const selectSelectedLanguage = (state) => state.languages.selectedLanguage;
export const selectLanguagesLoading = (state) => state.languages.loading;
export const selectLanguagesError = (state) => state.languages.error;

// Экспорт редьюсера
export default languagesSlice.reducer; 